export default "__VITE_ASSET__Cl8s2e3A__"